import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import DateTimeLabelViewModel from '@/ViewModels/Controls/DateTimeLabelViewModel';
import DateTimeLabel from '@/Controls/DateTimeLabel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class DateTimeLabelFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private DateTimeLabelViewModel = ComponentManager.getViewModel<typeof DateTimeLabelViewModel>('DateTimeLabelViewModel');
    private DateTimeLabel = ComponentManager.getControl<typeof DateTimeLabel>('DateTimeLabel')
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: DateTimeLabelViewModel;

    public showDate: boolean;
    public showTime: boolean;

    public constructor(private params: any) {
        super(params);

        if (this.params.useDefaultFormat === true)
            this.showDate = null;
        else
            this.showDate = this.paramOrDefault(this.params.showDate, true);

        if (this.params.useDefaultFormat === true)
            this.showTime = null;
        else
            this.showTime = this.paramOrDefault(this.params.showTime, true);
    }

    /**
     * @override
     */
    control: DateTimeLabel;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.DateTimeLabelViewModel({
            factory: this,
            isRequired: this.isRequired,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            showDate: this.showDate,
            showTime: this.showTime,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            isEnabled: this.isEnabled,
            parentLocator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            locator: this.detailViewItem.name
        })

        this.control = new this.DateTimeLabel(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('DateTimeLabel', DateTimeLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');